<template>
 <v-container>
      <v-col class="text-center" cols="12">
         <v-card outlined class="mt-1"> <h1 class="ma-2" v-html="presentacion[0].titulo"></h1></v-card>
         <v-card outlined class="mt-1"> <h1 class="ma-2" v-html="presentacion[0].pregunta"></h1></v-card>
    <!-- PREGUNTA UNICA RESPUESTA-->
    <v-card v-if="presentacion[0].tipo==='PU'" class="pl-2 pt-2 mt-2" color="grey lighten-3">
      <v-row>
        <v-col cols="8">
          <v-radio-group  :mandatory="false">
              <v-row>
               <v-col cols="12" v-for="item of presentacion[0].tareas" :key="item.id">
                 <v-alert  border="left" colored-border color="primary" elevation="2">
                   <v-radio  :label="item.respuesta"    @change="validarPreguntaUnica(item)"></v-radio>
                 </v-alert>
                </v-col>
             </v-row>
       </v-radio-group>
        </v-col>
        <v-col>
           <transition name="slide-fade" v-if="respuestaUnica">
               <v-alert :type="estado" class="mr-2">
                 <h3>Respuesta:</h3>
                 {{larespuesta}}
                </v-alert>
         </transition>
        </v-col>
      </v-row>
    </v-card>
      <!-- PREGUNTA MULTIPLE OPCIONES-->
    <v-card v-if="presentacion[0].tipo==='PM'" class="mt-2 pl-2 pb-2 pr-2" color="grey lighten-3" >
      <v-row v-if="respuestas">
        <v-col>
            <v-alert type="info">OPCIONES</v-alert>
             <ul>
            <li v-for="item of presentacion[0].tareas" :key="item.id">
            <h3 style="color:#43A047;" v-if="item.correcta===true">{{item.respuesta}} <v-icon color="success" class="ml-2">fa-check</v-icon></h3>
            <h3 style="color:#E53935;" v-else>{{item.respuesta}} <v-icon color="error" class="ml-2">fa-times</v-icon></h3>
          </li>
             </ul>
        </v-col>
        <v-col>
          <v-alert type="info">TUS RESPUESTAS</v-alert>
          <ul>
            <li v-for="i of  misRespuestas" :key="i.id">
            <h3 style="color:#43A047;" v-if="i.correcta===true">{{i.respuesta}} <v-icon color="success" class="ml-2">fa-check</v-icon></h3>
            <h3 style="color:#E53935;" v-else>{{i.respuesta}} <v-icon color="error" class="ml-2">fa-times</v-icon></h3>
          </li>
        </ul>
        </v-col>
        
      </v-row>
      <v-row v-if="opciones">
        <v-col v-for="item of presentacion[0].tareas" :key="item.id" cols="12">
             <v-alert  border="left" colored-border color="primary" elevation="2">
                   <v-checkbox v-model="correctas" :label="item.respuesta" :value="item"></v-checkbox>
              </v-alert>
        </v-col>
      </v-row>
      <v-btn class="primary" @click="validarPreguntaMultiple" v-if="validar">Validar</v-btn>
    </v-card>
    <!---RESPUESTA VERDADERO O FALSO -->
    <v-card class="mt-2" v-if="presentacion[0].tipo==='PV'">
                 <v-row>
        <v-col cols="6">
          <v-radio-group  :mandatory="false">
               <v-col v-for="item of presentacion[0].tareas" :key="item.id" >
                 <v-radio  :label="item.respuesta"  @change="validarVerdadero(item)"></v-radio>
                </v-col>
       </v-radio-group>
        </v-col>
        <v-col cols="6">
           <transition name="slide-fade" v-if="respuestaVerdadera">
               <v-alert :type="color" class="mr-2 mt-5">
                 <h3>Respuesta: {{tipo}}</h3>
                </v-alert>
         </transition>
        </v-col>
      </v-row>
    </v-card>
  </v-col>

      
 </v-container>
</template>

<script>
// import axios from "../../../helpers/axios";
    export default {
        name: 'vistaPreg1',
        props:{
          presentacion:{
            type:Array
          },
          respuestaVerdadera:{
             type:Boolean
          },
          respuestaUnica:{
            type:Boolean
          },
          respuestas:{
            type:Boolean
          },
          opciones:{
            type:Boolean
          },
          validar:{
            type:Boolean
          },
        },
    data() {
    return {  
     estado:'',
     volver:false,
     larespuesta:'',
     correctas:[],
     tipo:'',
     color:'',
     misRespuestas:[],
    };

  },
 
  mounted() {
     
      //this.acceso1()
    },


  methods: {
    


    validarPreguntaUnica(item){
      var tipo = 'prU'
        if(item.correcta===true){
          alert('Respuesta Correcta!!!');
          this.larespuesta = item.respuesta
          this.estado = 'success'
          this.$emit('comprobar',tipo);
        }else if(item.correcta===false){
          alert('Respuesta Incorrecta!!!');
           this.larespuesta = item.respuesta
            this.estado = 'error'
           this.$emit('comprobar',tipo);
        }
    },
    validarPreguntaMultiple(){
        if(this.correctas.length === 0){
          alert('Debe seleccionar al menos una opcion');
        }else{
          var tipo = 'prM'
          this.$emit('comprobar',tipo);
          this.volver = true
          this.validar = false
          this.misRespuestas = this.correctas
          this.correctas = []
        }
    },
    validarVerdadero(item){
           if(item.correcta===true){
          this.respuestaVerdadera = true
          this.tipo = "Correcta"
          this.color = "success"
        }else if(item.correcta===false){
          this.respuestaVerdadera = true
          this.tipo = "Incorrecta"
          this.color =  "error"
        }
    },
},

  components: {

  }
}
</script>

<style scoped>
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for <2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

</style>
